import { useQuery } from "react-query";
import { KTSVG } from "../../../../../../../../_metronic/helpers"
import { FormikErrorMessage, FormikTextInput } from "../../../../../../../components/widgets"
import { getSIRsByDOC } from "../../../../_requests";
import { Field, useFormikContext } from "formik";
import { useEffect, useRef } from "react";
import { MenuComponent } from "../../../../../../../../_metronic/assets/ts/components";
import { isPopulatedArray } from "../../../../../../../components/helpers";
import { IDOCLabelApplication } from "../core";
import clsx from "clsx";

export const DOCLabelSIRSelector = () => {
  
  const sirTimerRef: any = useRef();

  const { values, setFieldValue, setFieldTouched, validateField } = useFormikContext();

  const { certID, requiredSIR, appType, coverageArea, inspectionLevel, sirSelected } = values as IDOCLabelApplication;

  const { data: SIRList, isLoading } = useQuery({
    queryKey: ['DOCSIRS', certID],
    queryFn: async () => getSIRsByDOC(certID),
    enabled: (certID > 0) ? true : false,    
    staleTime: 600000,   // keep fresh for 10 mins (no refetch)
    cacheTime: 600000,   // clear from cache after 10 mins to free mem
  });

  // when appType is non-mandatory DOC, set required SIR
  useEffect(() => {
    
    const _cov = parseFloat(`0${coverageArea}`);
    const _level = parseFloat(`0${inspectionLevel}`);
    

    if (! (appType === 'DOC' && _cov > 0 && _level > 0 && (! (_cov < _level)))) {
      if (requiredSIR !== 0) {
        setFieldValue('requiredSIR', 0);     
      }
      return;        
    }    
    setFieldValue('requiredSIR', Math.ceil(_cov / _level));     
    setFieldTouched('sirSelected', true, true);
    
    if (sirTimerRef.current) {
      clearTimeout(sirTimerRef.current);
    }
    sirTimerRef.current = setTimeout(() => {
      validateField('sirSelected');
    }, 200);

    return () => {
      if (sirTimerRef.current) {
        clearTimeout(sirTimerRef.current);
      }
    }
  // eslint-disable-next-line
  },[appType, coverageArea, inspectionLevel, requiredSIR])


  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])
  
  return(  
  <div className="col-12 col-md-6">
    <div className="row">
      <div className="col-6 col-md-6" id="sir-checkbox-group">
        <label>
          <span className={clsx('fw-bold fs-7 me-2',{'required' : (requiredSIR > 0)})}>
            {`Select ${requiredSIR > 0 ? requiredSIR : ''} SIR:`}
          </span>
          { (isPopulatedArray(sirSelected)) && 
          <span className="text-muted fw-normal fs-8">{`(${sirSelected.length} selected)`}</span>
          }
        </label>
        
        <button
          type="button"
          className='d-block w-100 btn btn-sm btn-light-danger me-3 py-2'    
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-start'
          disabled={! (SIRList !== undefined && isPopulatedArray(Object.entries(SIRList)))}      
        >
          { (isLoading) ? (
          <>
          Loading ...{' '}
          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </>
          ) : (
          <>
          <KTSVG path='/media/icons/duotune/general/gen037.svg' className='svg-icon-4 svg-icon-gray-500' />
          Select SIR
          </>
          )}      
        </button>  
        <div
          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-2'
          data-kt-menu='true'
          role="group" aria-labelledby="sir-checkbox-group"
        >   
        { (SIRList !== undefined) && Object.entries(SIRList).map(vals => (
          <div key={`sirid_${vals[0]}`} className='menu-item px-3 form-check form-check-sm form-check-custom form-check-solid mt-2 d-flex flex-row align-items-start gap-2'>
            <Field type="checkbox" name="sirSelected" value={vals[0]} className='form-check-input' />
            <label className='form-check-label ps-2'>{`${vals[1]}`}</label>
          </div>
        ))}      
        </div>
      </div>
      <FormikTextInput size="12 col-md-6" label="Additional SIR" name="sirSelectedText" required={(requiredSIR > 0) && (! (SIRList !== undefined && isPopulatedArray(Object.entries(SIRList))))} />
    </div>  
    <div className="row">
      <FormikErrorMessage name="sirSelected" />
    </div>
  </div>
  )
}